module.exports = __webpack_public_path__ + "static/media/deviceIncompatibility.7f82328f.svg";